import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Link from '@mui/material/Link';
import PublicNavBar from '../public-navbar/publicNavBar';
import PublicMember from './PublicMember';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState, Fragment } from 'react';
import ProjectTag from './ProjectTag';

function ProjectViewPage(props) {
    const navigate = useNavigate();
    const { id } = useParams();

    const [members, setMembers] = useState([]);
    const [project, setProject] = useState({
        project_id: 0,
        class_id: 0,
        name: "",
        sponsor: "",
        sponsor_contact: "",
        description: "",
        start_semester: "",
        start_year: "",
        end_semester: "",
        end_year: "",
        capacity: 5,
        documents: null,
        tags: []
    });

    useEffect(() => {
        async function fetchData() {
            const res = await fetch(`${process.env.REACT_APP_API_HOST}/api/projects/getOne/${id}`);
            if (!res.ok) {
                console.error('failed to fetch project: ' + id, res);
                return;
            }
            const json = await res.json();
            setProject(json[0]);
        }
        fetchData();
    }, [id])

    useEffect(() => {
        // dont try to fetch the data if the project is the default
        if (project.project_id === 0) {
            return;
        }

        async function fetchMemberData() {
            const res = await fetch(`${process.env.REACT_APP_API_HOST}/api/projects/members/${project.project_id}`);
            if (!res.ok) {
                console.error('failed to fetch members for project: ' + project.project_id, res);
                return;
            }
            const json = await res.json();
            setMembers(json);
            console.log(json);
        }

        fetchMemberData();
    }, [project])

    return (
        <Box>
            <PublicNavBar />
            <Box sx={{ height: 'calc(100vh - 52.5px)', display: 'flex', flexDirection: 'row' }}>
                <Stack sx={{ width: '77.5vw' }}>
                    <Box sx={{ height: '325px', backgroundColor: 'white', overflowY: 'auto' }}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', px: 10, py: 5 }}>
                            <Button variant='contained' sx={{ color: 'white', backgroundColor: '#1B1B1B', maxWidth: 'fit-content' }} onClick={() => navigate(-1)}><ArrowBackIosNewIcon />BACK</Button>
                            <Typography variant='h3' sx={{ mt: 5, mb: 2 }}>{project.name}</Typography>
                            <Typography variant='h5' sx={{ mb: 2, fontStyle: 'italic' }}>Sponsor: {project.sponsor}</Typography>
                            <Typography variant='h5' sx={{ mb: 2, fontStyle: 'italic' }}>{project.end_semester + ' ' + project.end_year}</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ minHeight: 'calc(100% - 325px)', backgroundColor: 'black', overflowY: 'auto' }}>
                        <Box sx={{ px: 10, py: 5 }}>
                            <Typography variant='h4' sx={{ color: 'white', fontWeight: 'bold', pb: 3 }}>
                                Project Description:
                                <Box sx={{ background: 'none repeat scroll 0 0 #fc0', bottom: '-10px', content: '""', display: 'block', height: '4px', position: 'relative', width: '60px' }}></Box>
                            </Typography>
                            <Typography sx={{ color: 'white', fontSize: '18px', textAlign: 'justify', lineHeight: '3vh', pb: 3 }}>
                                {project.description}
                            </Typography>
                            <Typography variant='h4' sx={{ color: 'white', fontWeight: 'bold', pb: 3 }}>
                                Project Documents:
                                <Box sx={{ background: 'none repeat scroll 0 0 #fc0', bottom: '-10px', content: '""', display: 'block', height: '4px', position: 'relative', width: '60px' }}></Box>
                            </Typography>
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                {project.documents == null ? (
                                    <Typography variant='body1' sx={{ color: 'white' }}>
                                        No documents available.
                                    </Typography>
                                ) : (
                                    project.documents.map((file, i) => (
                                        <Fragment key={`viewFile${i}`}>
                                            <Link href={process.env.REACT_APP_API_HOST + "/" + file.filepath} target="_blank" rel="noopener noreferrer" color="#FFC904" sx={{ pb: 2 }}>{file.filename}</Link>
                                        </Fragment>
                                    ))
                                )}
                            </Box>
                            <Typography variant='h4' sx={{ color: 'white', fontWeight: 'bold', pb: 3, pt: 2 }}>
                                Key Words:
                                <Box sx={{ background: 'none repeat scroll 0 0 #fc0', bottom: '-10px', content: '""', display: 'block', height: '4px', position: 'relative', width: '60px' }}></Box>
                            </Typography>
                            <Typography sx={{ borderColor: '#FFC904', color: '#FFC904', fontSize: '20px', textAlign: 'justify', lineHeight: '3vh', pb: 3, mb: 2 }}>
                                {project.tag_maps?.map(tag_map => <ProjectTag tag={tag_map.tag.name} />)}
                            </Typography>
                        </Box>
                    </Box>
                </Stack>
                <Box sx={{ width: '22.5vw', backgroundColor: '#FFC904', justifyContent: 'center', alignItems: 'center', overflowY: 'scroll' }}>
                    {members && members.length > 0 && members.map((member, i) => (
                        <PublicMember key={`Member${i}`} name={member.first_name + " " + member.last_name} imgURL={member.photo} />
                    ))}
                </Box>
            </Box>
        </Box>
    );
}

export default ProjectViewPage;
